import {
  addDays,
  isToday,
  isTomorrow,
  isYesterday,
  startOfToday,
} from "date-fns";
import { humanFormat, machineFormat } from "@medoma/models/date-and-time";
import { useLingui } from "@lingui/react/macro";
import { Tab, TabList } from "react-aria-components";
import clsx from "clsx";
import styles from "./DaySwitcher.module.scss";

const DAYS_IN_PAST = 2;
const DAYS_IN_FUTURE = 5;

export const DaySwitcher = () => {
  const { t } = useLingui();

  const today = startOfToday();
  const days = Array.from(
    { length: DAYS_IN_PAST + DAYS_IN_FUTURE + 1 },
    (_, index) => addDays(today, index - DAYS_IN_PAST),
  );

  const dayLabel = (day: Date) => {
    if (isToday(day)) {
      return t`Idag`;
    }
    if (isYesterday(day)) {
      return t`Igår`;
    }
    if (isTomorrow(day)) {
      return t`Imorgon`;
    }
    return humanFormat(day, { weekday: "short", day: "numeric" });
  };

  return (
    <TabList className={styles.daysList} aria-label={t`Välj dag`}>
      {days.map((day) => (
        <Tab
          key={machineFormat(day, "yyyy-MM-dd")}
          id={machineFormat(day, "yyyy-MM-dd")}
          className={({ isSelected }) =>
            clsx(styles.dayButton, isSelected && styles.selected)
          }
        >
          {dayLabel(day)}
        </Tab>
      ))}
    </TabList>
  );
};
